module.exports = __webpack_public_path__ + "img/close.2c908951.svg";